import React, {
  createContext,
  useMemo,
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { usePersistState } from '@common/hooks/persistState';
import { checkTerminalMode } from '@common/helpers';
import ToastWrapper from '@common/helpers/toastWrapper';

const initialState = {
  events: {},
  boostedOddsGameIds: {},
  placeBetLoading: false,
  bookingAmount: null,
};

export const SelectionsContext = createContext([initialState, _.noop]);

let dispatcher;
let getValue = _.noop;

export const getSelectionsContextValue = () => [getValue(), dispatcher];

export const SelectionsContextProvider = ({ children, config }) => {
  const state = usePersistState(initialState, 'selections', ['placeBetLoading']);
  const [value, setValue] = state;

  getValue = () => value;
  dispatcher = setValue;

  const changeValue = useCallback((_newValue) => {
    setValue((oldValue) => {
      const newValue = typeof _newValue === 'function' ? _newValue(oldValue) : _newValue;

      if (Object.keys(newValue.events).length > config.betslip.maxSelectionsCount) {
        ToastWrapper('error', ['Max selection count is {1}', config.betslip.maxSelectionsCount]);
        return oldValue;
      }

      return newValue;
    });
  }, [config, setValue]);

  useEffect(() => {
    if (config.sportsbook.enableBoostedOdds && checkTerminalMode(config, 'betting')) {
      swarmRequest({}, 'get_boosted_selections').then((resp) => {
        setValue((newValue) => ({ ...newValue, boostedOddsGameIds: resp?.details || {} }));
      });
    }
  }, [config, setValue]);

  return (
    <SelectionsContext.Provider value={useMemo(() => [value, changeValue], [value, changeValue])}>
      {children}
    </SelectionsContext.Provider>
  );
};

SelectionsContextProvider.propTypes = {
  children: PropTypes.node,
  config: PropTypes.object,
};
